import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import styles from './cta_decorator.scss'
const cx = classNames.bind(styles)

const Cta = InnerComponent => {
	class NewCta extends Component {

		constructor() {
			super()
			this.onFocusHandler = this.onFocusHandler.bind(this)
			this.onBlurHandler = this.onBlurHandler.bind(this)

			this.state = {
				isInFocus: false,
			}
		}

		onFocusHandler() {
			this.setState({ isInFocus: true })
		}

		onBlurHandler() {
			this.setState({ isInFocus: false })
		}

		render() {
			const innerProps = Object.assign({}, this.props)

			const nativeProps = Object.assign({}, this.props)
			delete nativeProps.bgColor
			delete nativeProps.fontColor
			delete nativeProps.pill
			delete nativeProps.focus
			delete nativeProps.tabIndex
			delete nativeProps.autoFocus
			delete nativeProps.icon
			delete nativeProps.linkClick
			delete nativeProps.onFocusHandler
			delete nativeProps.onBlurHandler
			delete nativeProps.useEllipsis
			delete nativeProps.isUnderlined

			if (nativeProps.onClick || nativeProps.onMouseDown || nativeProps.type === 'submit') {

				delete innerProps.onClick
				delete innerProps.onMouseDown
				return (
					<button
						{...nativeProps}
						className={cx(this.props.className, styles['cta-btn'])}
						onFocus={this.props.onFocusHandler || this.onFocusHandler}
						onBlur={this.props.onBlurHandler || this.onBlurHandler}
					>
						<InnerComponent
							{...innerProps}
							isInFocus={this.state.isInFocus}
						/>
					</button>
				)

			} else if (nativeProps.href) {

				delete innerProps.href
				return (
					<a
						{...nativeProps}
						tabIndex={this.props.tabIndex}
						target={nativeProps.target || '_self'}
						onClick={this.props.linkClick}
						onFocus={this.onFocusHandler}
						onBlur={this.onBlurHandler}
					>
						<InnerComponent
							{...innerProps}
							isInFocus={this.state.isInFocus}
						/>
					</a>
				)

			} else if (nativeProps.to) {

				delete innerProps.to
				return (
					<Link
						{...nativeProps}
						onClick={this.props.linkClick}
						onFocus={this.onFocusHandler}
						onBlur={this.onBlurHandler}
					>
						<InnerComponent
							{...innerProps}
							isInFocus={this.state.isInFocus}
						/>
					</Link>
				)

			} else {
				return <InnerComponent {...innerProps} />
			}

		}
	}

	NewCta.defaultProps = {
		type: 'button',
	}

	NewCta.propTypes = {
		onMouseDown: PropTypes.func,
		href: PropTypes.string,
		to: PropTypes.string,
		onClick: PropTypes.func,
		onFlip: PropTypes.func,
		disabled: PropTypes.bool,
		type: PropTypes.string,
	}

	return NewCta
}


export default Cta
